(function () {
  'use strict';

  // =========================
  // CONFIG
  // =========================
  var TENANT = 'ima';

  // guarda filtros iniciais para o custom-filters
  var initialVehicleFilters = null;

  // =========================
  // BOOT
  // =========================
  waitForElement('.custom-search-nav', iniciarBuscaCustomizada);

  function waitForElement(selector, callback) {
    if (document.querySelector(selector)) callback();
    else
      requestAnimationFrame(function () {
        waitForElement(selector, callback);
      });
  }

  // =========================
  // HELPERS
  // =========================
  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }
  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function setLoading(el, on) {
    if (!el) return;
    el.classList.toggle('loading', !!on);
  }

  function uniq(arr) {
    return Array.from(new Set((arr || []).filter(Boolean)));
  }
  function uniqSorted(arr) {
    return uniq(arr).sort(function (a, b) {
      return String(a).localeCompare(String(b), 'pt-BR', { numeric: true });
    });
  }
  function uniqSortedNum(arr) {
    return uniq(arr).sort(function (a, b) {
      return Number(a) - Number(b);
    });
  }

  function safeJSONParse(v, fallback) {
    try {
      return JSON.parse(v);
    } catch (_) {
      return fallback;
    }
  }

  function getPlacaFromStorage() {
    var raw = localStorage.getItem('dadosVeiculoPorPlaca');
    if (!raw) return '';
    var obj = safeJSONParse(raw, null);
    return ((obj && (obj.placa || obj.PLACA)) || '').toString().trim();
  }

  // =========================
  // API HELPERS
  // =========================
  function api(url) {
    return fetch(url).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status + ' @ ' + url);
      return r.json();
    });
  }

  function urlFilters(path, paramsObj) {
    var params = new URLSearchParams();
    Object.keys(paramsObj || {}).forEach(function (k) {
      var v = paramsObj[k];
      if (v != null && v !== '') params.set(k, v);
    });
    return 'https://search-api.wedigi.house/api/' + TENANT + path + '?' + params.toString();
  }

  // =========================
  // FAKE SELECT
  // =========================

  // Controla dependência em cadeia: se o select anterior não estiver preenchido, bloqueia
  function canOpenFakeSelect(select) {
    if (!select) return true;

    var depSelector = select.getAttribute('data-depends-on');
    if (!depSelector) return true;

    var depEl = document.querySelector(depSelector);
    if (!depEl) return true;

    var hasValue = !!(depEl.value || '').trim();
    if (hasValue) return true;

    // Destaque visual no campo obrigatório anterior
    var depWrapper = depEl.closest('.select-wrapper');
    if (depWrapper) {
      depWrapper.classList.add('select-wrapper--required');
      setTimeout(function () {
        depWrapper.classList.remove('select-wrapper--required');
      }, 800);
    }

    // Foca no select anterior
    depEl.focus();
    return false;
  }

  // Sincroniza disabled do fake select com a dependência (data-depends-on)
  function syncFakeSelectDisabledByDependency(select) {
    if (!select) return;

    var depSelector = select.getAttribute('data-depends-on');
    var wrapper = select.closest('.select-wrapper');
    if (!wrapper) return;

    var fake = wrapper.querySelector('.fake-select');
    var input = fake && fake.querySelector('.fake-select-input');
    var listWrap = fake && fake.querySelector('.fake-select-list-wrap');

    var disabled = false;

    if (depSelector) {
      var depEl = document.querySelector(depSelector);
      if (!depEl || !(depEl.value || '').trim()) {
        disabled = true;
      }
    }

    // desabilita o select nativo também, só por consistência
    select.disabled = disabled;

    if (input) input.disabled = disabled;
    if (listWrap) listWrap.classList.toggle('fake-select-disabled', disabled);
    wrapper.classList.toggle('fake-select-disabled', disabled);
  }

  // Cria o fake select para um <select>
  function ensureFakeSelect(select) {
    var wrapper = select.closest('.select-wrapper');
    if (!wrapper) return;

    if (wrapper.querySelector('.fake-select')) return;

    var fake = document.createElement('div');
    fake.className = 'fake-select';

    fake.innerHTML = [
      '<div class="fake-select-search">',
      '  <input type="text" class="fake-select-input" placeholder="Digite para filtrar..." />',
      '  <span class="fake-select-icon" aria-hidden="true"></span>',
      '</div>',
      '<div class="fake-select-body">',
      '  <div class="fake-select-hint">Selecione:</div>',
      '  <div class="fake-select-list-wrap">',
      '    <ul class="fake-select-list"></ul>',
      '  </div>',
      '</div>',
    ].join('');

    wrapper.insertBefore(fake, select);

    // esconde o select nativo
    select.style.display = 'none';

    var input = fake.querySelector('.fake-select-input');
    var listWrap = fake.querySelector('.fake-select-list-wrap');

    // por padrão: dropdown escondido
    if (listWrap) listWrap.style.display = 'none';

    // abre ao focar
    input.addEventListener('focus', function () {
      if (!canOpenFakeSelect(select)) return;
      updateFakeSelect(select, true);
    });

    // digitar → filtra e mantém aberto
    input.addEventListener('input', function () {
      if (!canOpenFakeSelect(select)) {
        input.value = '';
        updateFakeSelect(select, false);
        return;
      }
      updateFakeSelect(select, true);
    });

    // blur → fecha (com timeout para permitir clique na lista)
    input.addEventListener('blur', function () {
      setTimeout(function () {
        updateFakeSelect(select, false);
      }, 150);
    });

    var list = fake.querySelector('.fake-select-list');
    list.addEventListener('click', function (e) {
      var li = e.target.closest('li');
      if (!li || li.classList.contains('fake-select-empty')) return;
      var value = li.dataset.value || li.textContent || '';

      input.value = value;
      select.value = value;

      var ev = new Event('change', { bubbles: true });
      select.dispatchEvent(ev);

      // selecionou → fecha dropdown
      updateFakeSelect(select, false);
    });
  }

  /**
   * Atualiza a lista do fake select.
   * @param {HTMLSelectElement} select
   * @param {boolean|undefined} open - true abre, false fecha, undefined mantém estado atual.
   */
  function updateFakeSelect(select, open) {
    var wrapper = select.closest('.select-wrapper');
    if (!wrapper) return;

    var fake = wrapper.querySelector('.fake-select');
    if (!fake) return;

    var listWrap = fake.querySelector('.fake-select-list-wrap');
    var list = fake.querySelector('.fake-select-list');
    var input = fake.querySelector('.fake-select-input');

    if (!listWrap || !list || !input) return;

    var term = (input.value || '').toLowerCase();

    var options = Array.prototype.slice.call(select.options || []).slice(1); // ignora placeholder

    var values = options
      .map(function (opt) {
        return opt.value || opt.textContent || '';
      })
      .filter(Boolean)
      .filter(function (v) {
        return !term || v.toLowerCase().indexOf(term) !== -1;
      })
      .sort(function (a, b) {
        return a.localeCompare(b, 'pt-BR', { numeric: true });
      });

    list.innerHTML = '';

    if (!values.length) {
      var emptyLi = document.createElement('li');
      emptyLi.className = 'fake-select-empty';
      emptyLi.textContent = 'Nenhum resultado';
      list.appendChild(emptyLi);

      // se não tem itens, dropdown fica oculto
      listWrap.style.display = 'none';
      return;
    }

    values.forEach(function (v) {
      var li = document.createElement('li');
      li.textContent = v;
      li.dataset.value = v;
      list.appendChild(li);
    });

    // controla abertura/fechamento
    if (open === true) {
      listWrap.style.display = 'block';
    } else if (open === false) {
      listWrap.style.display = 'none';
    }
    // se open for undefined, mantém o estado atual (não mexe em display)
  }

  // =========================
  // OPTIONS HELPER
  // =========================
  function preencherOptions(select, data) {
    if (!select) return;

    select.innerHTML = '<option>Carregando...</option>';
    select.disabled = true;
    select.classList.add('loading');

    setTimeout(function () {
      var values = (data || [])
        .map(function (item) {
          if (typeof item === 'string') return item;
          if (!item) return '';

          return (
            item.value ||
            item.name ||
            item.label ||
            item.description ||
            item.vehicleName ||
            item.group ||
            item.manufacturer ||
            ''
          );
        })
        .filter(Boolean);

      values = uniqSorted(values);

      if (!values.length) {
        console.warn('preencherOptions sem valores para', select.id, 'com data:', data);
      }

      select.innerHTML = '<option value="">Pesquise...</option>';
      values.forEach(function (value) {
        var opt = document.createElement('option');
        opt.value = value;
        opt.textContent = value;
        select.appendChild(opt);
      });

      select.disabled = false;
      select.classList.remove('loading');

      // preenche lista mas deixa fechada; só abre quando focar
      updateFakeSelect(select, false);
    }, 50);
  }

  // =========================
  // CONFIRM / MODAL FLOW
  // =========================
  function buildConfirmedURL(base, selected) {
    var params = new URLSearchParams();
    if (base.query) params.set('query', base.query);
    if (base.year) params.set('year', base.year);
    if (base.manufacturer) params.set('manufacturer', base.manufacturer);

    var confName = selected.vehicleName || selected.model || selected.vehicleModel || '';
    var confYear = selected.vehicleYear || selected.year || selected.vehicle_year || '';
    var confDesc = selected.vehicleDescription || selected.description || '';
    var confBrand =
      selected.vehicleManufacturerName || selected.manufacturer || selected.vehicleManufacturer || selected.brand || '';

    if (confName) params.set('confirmedVehicleName', confName);
    if (confYear) params.set('confirmedVehicleYear', confYear);
    if (confDesc) params.set('confirmedVehicleDescription', confDesc);
    if (confBrand) params.set('confirmedVehicleManufacturer', confBrand);

    var anyId = selected.vehicleId || selected.id || selected.code || '';
    var placa = getPlacaFromStorage();
    params.set('vechicleIdCode', anyId || placa || '');

    return 'https://search-api.wedigi.house/api/' + TENANT + '/filters/vehicles/search?' + params.toString();
  }

  function doConfirmedSearch(base, selected) {
    var results = qs('#search-results');
    setLoading(results, true);
    return api(buildConfirmedURL(base, selected))
      .then(function (data) {
        if (data && Array.isArray(data.vechicleOptions) && data.vechicleOptions.length > 0) {
          renderizarModalVeiculo(data.vechicleOptions, base);
        } else {
          renderizarResultados(data && (data.data || data));
        }
      })
      .catch(function (err) {
        console.error('Erro na busca confirmada:', err);
        alert('Não foi possível concluir a busca confirmada.');
      })
      .finally(function () {
        setLoading(results, false);
      });
  }

  function handleSearchResponse(payload, base) {
    if (payload && Array.isArray(payload.vechicleOptions) && payload.vechicleOptions.length > 0) {
      renderizarModalVeiculo(payload.vechicleOptions, base);
    } else {
      renderizarResultados(payload && (payload.data || payload));
    }
  }

  function renderizarModalVeiculo(veiculos, base) {
    var old = qs('.vehicle-modal');
    if (old && old.parentNode) old.parentNode.removeChild(old);

    var modal = document.createElement('div');
    modal.className = 'vehicle-modal';
    modal.innerHTML = [
      '<div class="vehicle-modal-content">',
      '<span class="vehicle-modal-close">&times;</span>',
      '<h2><small>Encontramos mais de uma possibilidade!</small> Ajude-nos a identificar a versão correta:</h2>',
      '<div class="vehicle-options">',
      '<div class="vehicle-option header">',
      '<span>Marca</span>',
      '<span>Modelo</span>',
      '<span>Ano</span>',
      '<span>Especificação</span>',
      '<span></span>',
      '</div>',
      (veiculos || [])
        .map(function (v, idx) {
          return [
            '<div class="vehicle-option" data-index="',
            idx,
            '">',
            '<span>',
            v.vehicleManufacturerName || 'Não encontrado',
            '</span>',
            '<span>',
            v.vehicleName || 'Não encontrado',
            '</span>',
            '<span>',
            v.vehicleYear || 'Não encontrado',
            '</span>',
            '<span>',
            v.vehicleDescription || 'Não encontrado',
            '</span>',
            '<span><button type="button" class="btn-select">Selecionar</button></span>',
            '</div>',
          ].join('');
        })
        .join(''),
      '</div>',
      '</div>',
    ].join('');

    document.body.appendChild(modal);

    function close() {
      if (modal && modal.parentNode) modal.parentNode.removeChild(modal);
    }

    qs('.vehicle-modal-close', modal)?.addEventListener('click', close);
    window.addEventListener('click', function (ev) {
      if (ev.target === modal) close();
    });

    qsa('.vehicle-option:not(.header)', modal).forEach(function (row) {
      var idx = Number(row.getAttribute('data-index'));
      var btn = qs('.btn-select', row);
      if (!btn) return;
      btn.addEventListener('click', function () {
        var selected = veiculos[idx];
        close();
        doConfirmedSearch(base || { query: '', year: '', manufacturer: '' }, selected);
      });
    });
  }

  // =========================
  // RENDER: RESULTADOS
  // =========================
  function renderizarResultados(data) {
    console.log('🚀 ~ renderizarResultados ~ data:', data);
    var el = qs('#search-results');
    if (!el) return;
    el.innerHTML = '';
    setLoading(el, false);

    if (!Array.isArray(data) || data.length === 0) {
      el.innerHTML = '<p>Nenhum resultado encontrado.</p>';
      return;
    }

    function getApps(item) {
      var raw = item.productApplication || [];
      if (!Array.isArray(raw)) return [];
      return raw.map(function (a) {
        return {
          fabricante: a.vehicleManufacturerName || a.manufacturer || a.vehicleManufacturer || a.brand || '',
          modelo: a.vehicleName || a.model || a.vehicleModel || '',
          ano: a.vehicleYear || a.year || a.vehicle_year || '',
        };
      });
    }

    var allApps = data.flatMap(getApps);
    var fabricantes = uniqSorted(
      allApps.map(function (a) {
        return a.fabricante;
      })
    );
    var modelosAll = uniqSorted(
      allApps.map(function (a) {
        return a.modelo;
      })
    );
    var anosAll = uniqSortedNum(
      allApps.map(function (a) {
        return a.ano;
      })
    );

    var filtrosHTML = [
      '<div class="custom-filters">',
      '<label>Montadora:',
      '<select id="filtro-fabricante">',
      '<option value="">Todos</option>',
      fabricantes
        .map(function (f) {
          return '<option>' + f + '</option>';
        })
        .join(''),
      '</select>',
      '</label>',
      '<label>Modelo:',
      '<select id="filtro-modelo">',
      '<option value="">Todos</option>',
      modelosAll
        .map(function (m) {
          return '<option>' + m + '</option>';
        })
        .join(''),
      '</select>',
      '</label>',
      '<label>Ano:',
      '<select id="filtro-ano">',
      '<option value="">Todos</option>',
      anosAll
        .map(function (a) {
          return '<option>' + a + '</option>';
        })
        .join(''),
      '</select>',
      '</label>',
      '</div>',
    ].join('');
    el.insertAdjacentHTML('beforeend', filtrosHTML);

    var lista = document.createElement('div');
    lista.className = 'result-list';
    el.appendChild(lista);

    var selFabricante = qs('#filtro-fabricante');
    var selModelo = qs('#filtro-modelo');
    var selAno = qs('#filtro-ano');

    function setOptions(selectEl, values, placeholderText) {
      if (!selectEl) return;
      var html = ['<option value="">' + (placeholderText || 'Todos') + '</option>']
        .concat(
          values.map(function (v) {
            return '<option>' + v + '</option>';
          })
        )
        .join('');
      selectEl.innerHTML = html;
      selectEl.value = '';
    }

    function rebuildDependentOptions() {
      var fabricante = selFabricante?.value || '';
      var modelo = selModelo?.value || '';

      var modelosFiltered = uniqSorted(
        allApps
          .filter(function (a) {
            return !fabricante || a.fabricante === fabricante;
          })
          .map(function (a) {
            return a.modelo;
          })
      );
      setOptions(selModelo, modelosFiltered, 'Todos');

      var anosFiltered = uniqSortedNum(
        allApps
          .filter(function (a) {
            if (fabricante && a.fabricante !== fabricante) return false;
            if (modelo && a.modelo !== modelo) return false;
            return true;
          })
          .map(function (a) {
            return a.ano;
          })
      );
      setOptions(selAno, anosFiltered, 'Todos');
    }

    function aplicarFiltros() {
      var fabricante = selFabricante?.value || '';
      var modelo = selModelo?.value || '';
      var ano = selAno?.value || '';
      var hasFilter = !!(fabricante || modelo || ano);

      lista.innerHTML = '';

      data.forEach(function (raw) {
        var item = (raw && (raw.product || raw)) || {};
        var description = item.description || '';
        var code = item.code || '';
        var pic01 = item.pic01 || '';
        var attributes = Array.isArray(item.attributes) ? item.attributes : [];
        var shopifySlug = item.shopifySlug;

        var apps = getApps(raw);

        var ok = !hasFilter
          ? true
          : apps.length > 0 &&
            apps.some(function (app) {
              var mf = !fabricante || app.fabricante === fabricante;
              var mm = !modelo || app.modelo === modelo;
              var my = !ano || String(app.ano) === String(ano);
              return mf && mm && my;
            });

        if (!ok) return;

        var validAttr = attributes.filter(function (a) {
          return a && a.value && String(a.value).trim();
        });
        var attrHTML = validAttr
          .map(function (a) {
            return '<span class="attribute"><strong>' + (a.label || '') + ':</strong> ' + a.value + '</span>';
          })
          .join('');

        var href = shopifySlug ? '/products/' + shopifySlug : '#';
        var itemHTML = [
          '<a href="' + href + '" class="search-result-item">',
          pic01 ? '<img src="' + pic01 + '" alt="' + (description || code || '') + '">' : '',
          '<div class="search-result-info">',
          '<h3>' + (description || '') + '</h3>',
          '<div class="code">Código: ' + (code || '') + '</div>',
          attrHTML ? '<div class="attributes">' + attrHTML + '</div>' : '',
          '</div>',
          '</a>',
        ].join('');

        lista.insertAdjacentHTML('beforeend', itemHTML);
      });

      if (!lista.innerHTML) {
        lista.innerHTML = '<p>Nenhum resultado com os filtros aplicados.</p>';
      }
    }

    // monta opções base
    rebuildDependentOptions();
    aplicarFiltros();

    // *** NOVO: aplica os filtros iniciais vindos dos combos, se houver ***
    if (initialVehicleFilters) {
      var init = initialVehicleFilters;

      if (init.fabricante && selFabricante) {
        selFabricante.value = init.fabricante;
      }

      // recalcula dependentes (modelo/ano) com base na montadora
      rebuildDependentOptions();

      if (init.modelo && selModelo) {
        selModelo.value = init.modelo;
      }

      // recalcula anos disponíveis com base em fabricante + modelo
      var fabricanteVal = (selFabricante && selFabricante.value) || '';
      var modeloVal = (selModelo && selModelo.value) || '';
      var anosFiltered = uniqSortedNum(
        allApps
          .filter(function (a) {
            if (fabricanteVal && a.fabricante !== fabricanteVal) return false;
            if (modeloVal && a.modelo !== modeloVal) return false;
            return true;
          })
          .map(function (a) {
            return a.ano;
          })
      );
      setOptions(selAno, anosFiltered, 'Todos');

      if (init.ano && selAno) {
        selAno.value = init.ano;
      }

      // reaplica filtros com os valores iniciais
      aplicarFiltros();

      // limpa o estado para próximas buscas
      initialVehicleFilters = null;
    }

    // listeners dos filtros
    selFabricante?.addEventListener('change', function () {
      rebuildDependentOptions();
      aplicarFiltros();
    });

    selModelo?.addEventListener('change', function () {
      var fabricante = selFabricante?.value || '';
      var modelo = selModelo?.value || '';

      var anosFiltered = uniqSortedNum(
        allApps
          .filter(function (a) {
            if (fabricante && a.fabricante !== fabricante) return false;
            if (modelo && a.modelo !== modelo) return false;
            return true;
          })
          .map(function (a) {
            return a.ano;
          })
      );
      setOptions(selAno, anosFiltered, 'Todos');

      aplicarFiltros();
    });

    selAno?.addEventListener('change', aplicarFiltros);
  }

  // =========================
  // BUSCAS
  // =========================
  function buscarGeral(termo) {
    var el = qs('#search-results');
    var q = (termo || '').trim();
    if (!q) {
      alert('Digite um termo para a busca geral.');
      setLoading(el, false);
      return;
    }
    setLoading(el, true);
    api(urlFilters('/filters/general/search', { query: q }))
      .then(function (data) {
        renderizarResultados(data);
      })
      .catch(function (err) {
        console.error('Erro na busca geral:', err);
        alert('Não foi possível realizar a busca geral. Tente novamente.');
      })
      .finally(function () {
        setLoading(el, false);
      });
  }

  // *** AJUSTADO: sempre usar /filters/vehicles/search e montar query ***
  function buscarPorVeiculo(tab) {
    var tipo = qs('#select-tipo')?.value;
    var fabricante = qs('#select-marca')?.value;
    var veiculo = qs('#select-modelo')?.value;
    var produto = qs('#select-descricao')?.value;
    var sistema = null;

    // pega especificamente o input principal de busca por veículo
    var inputBuscaVeiculo = qs('#search-vehicles', tab);
    var textoBuscaVeiculo = (inputBuscaVeiculo && inputBuscaVeiculo.value && inputBuscaVeiculo.value.trim()) || '';

    var hasFilters = !!(tipo || fabricante || veiculo || produto || sistema);

    // monta query
    var q = textoBuscaVeiculo;
    if (!q && hasFilters) {
      q = [tipo, fabricante, veiculo, produto].filter(Boolean).join(' ');
    }

    if (!q) {
      alert('Preencha pelo menos um campo para realizar a busca.');
      setLoading(qs('#search-results'), false);
      return;
    }

    // se for busca via combos (sem texto livre), prepara filtros iniciais para o custom-filters
    if (!textoBuscaVeiculo && hasFilters) {
      initialVehicleFilters = {
        fabricante: fabricante || '',
        modelo: veiculo || '',
        ano: '', // combos não têm ano, deixamos vazio
      };
    } else {
      initialVehicleFilters = null;
    }

    var url = urlFilters('/filters/vehicles/search', { query: q });

    var results = qs('#search-results');
    setLoading(results, true);

    api(url)
      .then(function (search) {
        var base = {
          query: q,
          year: '',
          manufacturer: fabricante || '',
        };

        var findFor = search.data || search;
        handleSearchResponse(findFor, base);
      })
      .catch(function (err) {
        console.error('Erro ao buscar peças por veículo:', err);
        alert('Erro ao buscar peças por veículo.');
      })
      .finally(function () {
        setLoading(results, false);
      });
  }

  function buscarPorCodigoDaPeca(codigo) {
    var el = qs('#search-results');
    var q = (codigo || '').trim();
    if (!q) {
      alert('Digite o código da peça.');
      setLoading(el, false);
      return;
    }
    setLoading(el, true);

    api(urlFilters('/filters/items/search', { query: q }))
      .then(function (data) {
        renderizarResultados(data);
      })
      .catch(function (err) {
        console.error('Erro ao buscar código da peça:', err);
        alert('Não foi possível buscar o código da peça.');
      })
      .finally(function () {
        setLoading(el, false);
      });
  }

  // =========================
  // UI: INTERAÇÕES VEÍCULO
  // =========================
  function configurarInteracoesDeVeiculo() {
    var abaVeiculo = qs('.tab-content.veiculo');
    if (!abaVeiculo) return;

    var selectTipo = qs('#select-tipo', abaVeiculo);
    var selectMarca = qs('#select-marca', abaVeiculo);
    var selectModelo = qs('#select-modelo', abaVeiculo);
    var selectDescricao = qs('#select-descricao', abaVeiculo);

    var selects = [selectTipo, selectMarca, selectModelo, selectDescricao];
    var inputTexto = qs('#search-vehicles', abaVeiculo);

    // Define a cadeia: cada select depende do anterior
    if (selectMarca) selectMarca.setAttribute('data-depends-on', '#select-tipo');
    if (selectModelo) selectModelo.setAttribute('data-depends-on', '#select-marca');
    if (selectDescricao) selectDescricao.setAttribute('data-depends-on', '#select-modelo');

    selects.forEach(function (s) {
      if (s) ensureFakeSelect(s);
    });

    // Aplica disabled inicial baseado nas dependências
    syncFakeSelectDisabledByDependency(selectMarca);
    syncFakeSelectDisabledByDependency(selectModelo);
    syncFakeSelectDisabledByDependency(selectDescricao);

    function resetCascata(fromSelect) {
      var idx = selects.indexOf(fromSelect);
      for (var i = idx; i < selects.length; i++) {
        var s = selects[i];
        if (!s) continue;
        s.innerHTML = '<option value="">Pesquise...</option>';
        s.disabled = true;
        s.classList.remove('loading');
        updateFakeSelect(s, false); // limpa e fecha dropdown

        var wrapper = s.closest('.select-wrapper');
        if (wrapper) {
          var fakeInput = wrapper.querySelector('.fake-select-input');
          var fakeListWrap = wrapper.querySelector('.fake-select-list-wrap');
          if (fakeInput) {
            fakeInput.value = '';
          }
          if (fakeListWrap) {
            fakeListWrap.style.display = 'none';
            fakeListWrap.classList.remove('fake-select-disabled');
          }
          wrapper.classList.remove('fake-select-disabled');
        }
      }
      fromSelect.disabled = false;
    }

    // TIPO DE VEÍCULO
    api('https://search-api.wedigi.house/api/' + TENANT + '/filters/vehicles/types')
      .then(function (data) {
        var list;
        if (Array.isArray(data)) {
          list = data;
        } else if (data && Array.isArray(data.data)) {
          list = data.data;
        } else if (data && Array.isArray(data.types)) {
          list = data.types;
        } else {
          console.warn('Formato inesperado para /filters/vehicles/types:', data);
          list = [];
        }
        preencherOptions(selectTipo, list);
      })
      .catch(function (err) {
        console.error('Erro tipos:', err);
      });

    // TIPO -> MONTADORA
    selectTipo.addEventListener('change', function () {
      var tipo = selectTipo.value;
      resetCascata(selectMarca);
      if (!tipo) {
        // se limpou o tipo, garante que dependentes fiquem desabilitados
        syncFakeSelectDisabledByDependency(selectMarca);
        syncFakeSelectDisabledByDependency(selectModelo);
        syncFakeSelectDisabledByDependency(selectDescricao);
        return;
      }

      syncFakeSelectDisabledByDependency(selectMarca);
      // modelo e descrição continuam dependentes da cadeia
      syncFakeSelectDisabledByDependency(selectModelo);
      syncFakeSelectDisabledByDependency(selectDescricao);

      selectMarca.innerHTML = '<option>Carregando...</option>';
      selectMarca.disabled = true;
      selectMarca.classList.add('loading');
      updateFakeSelect(selectMarca, false);

      api(
        'https://search-api.wedigi.house/api/' +
          TENANT +
          '/filters/vehicles/manufacturers?type=' +
          encodeURIComponent(tipo)
      )
        .then(function (data) {
          preencherOptions(selectMarca, data);
          // depois de preencher, re-sincroniza dependência
          syncFakeSelectDisabledByDependency(selectMarca);
        })
        .catch(function (err) {
          console.error('Erro marcas:', err);
          selectMarca.innerHTML = '<option value="">Erro ao carregar</option>';
          selectMarca.classList.remove('loading');
          updateFakeSelect(selectMarca, false);
          syncFakeSelectDisabledByDependency(selectMarca);
        });
    });

    // MONTADORA -> VEÍCULO
    selectMarca.addEventListener('change', function () {
      var tipo = selectTipo.value;
      var fabricante = selectMarca.value;
      resetCascata(selectModelo);

      syncFakeSelectDisabledByDependency(selectModelo);
      syncFakeSelectDisabledByDependency(selectDescricao);

      if (!tipo || !fabricante) {
        return;
      }

      selectModelo.innerHTML = '<option>Carregando...</option>';
      selectModelo.disabled = true;
      selectModelo.classList.add('loading');
      updateFakeSelect(selectModelo, false);

      api(
        'https://search-api.wedigi.house/api/' +
          TENANT +
          '/filters/vehicles/models?type=' +
          encodeURIComponent(tipo) +
          '&manufacturer=' +
          encodeURIComponent(fabricante)
      )
        .then(function (data) {
          preencherOptions(selectModelo, data);
          syncFakeSelectDisabledByDependency(selectModelo);
        })
        .catch(function (err) {
          console.error('Erro modelos:', err);
          selectModelo.innerHTML = '<option value="">Erro ao carregar</option>';
          selectModelo.classList.remove('loading');
          updateFakeSelect(selectModelo, false);
          syncFakeSelectDisabledByDependency(selectModelo);
        });
    });

    // VEÍCULO -> PRODUTO (groups)
    selectModelo.addEventListener('change', function () {
      var tipo = selectTipo.value;
      var fabricante = selectMarca.value;
      var modelo = selectModelo.value;
      resetCascata(selectDescricao);

      syncFakeSelectDisabledByDependency(selectDescricao);

      if (!tipo || !fabricante || !modelo) return;

      selectDescricao.innerHTML = '<option>Carregando...</option>';
      selectDescricao.disabled = true;
      selectDescricao.classList.add('loading');
      updateFakeSelect(selectDescricao, false);

      api(
        'https://search-api.wedigi.house/api/' +
          TENANT +
          '/filters/vehicles/groups?type=' +
          encodeURIComponent(tipo) +
          '&manufacturer=' +
          encodeURIComponent(fabricante) +
          '&vehicleName=' +
          encodeURIComponent(modelo)
      )
        .then(function (data) {
          preencherOptions(selectDescricao, data);
          syncFakeSelectDisabledByDependency(selectDescricao);
        })
        .catch(function (err) {
          console.error('Erro grupos (produto):', err);
          selectDescricao.innerHTML = '<option value="">Erro ao carregar</option>';
          selectDescricao.classList.remove('loading');
          updateFakeSelect(selectDescricao, false);
          syncFakeSelectDisabledByDependency(selectDescricao);
        });
    });

    // trava input texto se selects usados e vice-versa
    if (inputTexto) {
      inputTexto.addEventListener('input', function () {
        var temTexto = (inputTexto.value || '').trim().length > 0;
        selects.forEach(function (s) {
          if (!s) return;
          s.disabled = temTexto;
          var wrapper = s.closest('.select-wrapper');
          if (wrapper) {
            var fakeInput = wrapper.querySelector('.fake-select-input');
            var fakeListWrap = wrapper.querySelector('.fake-select-list-wrap');
            if (fakeInput) fakeInput.disabled = temTexto;
            if (fakeListWrap) fakeListWrap.classList.toggle('fake-select-disabled', temTexto);
            wrapper.classList.toggle('fake-select-disabled', temTexto);
          }
        });
      });
    }

    selects.forEach(function (s) {
      if (!s) return;
      s.addEventListener('change', function () {
        var algum = selects.some(function (sel) {
          return sel && (sel.value || '').trim();
        });
        if (inputTexto) inputTexto.disabled = algum;
      });
    });
  }

  // =========================
  // INICIALIZA BUSCA/TABS
  // =========================
  function iniciarBuscaCustomizada() {
    var navItems = qsa('.custom-search-nav ul li');
    var tabContents = qsa('.tab-content');
    var buscarBtn = qs('#buscar-btn');
    var limparBtn = qs('.buscar-btn.outline');
    var searchResults = qs('#search-results');

    // Tabs
    navItems.forEach(function (item) {
      item.addEventListener('click', function () {
        var selectedTab = (item.textContent || '').trim();
        navItems.forEach(function (i) {
          i.classList.remove('active');
        });
        item.classList.add('active');

        tabContents.forEach(function (content) {
          content.classList.toggle('active', content.dataset.tab === selectedTab);
        });

        limparResultadosRenderizados();
      });
    });

    // Botão Buscar
    buscarBtn &&
      buscarBtn.addEventListener('click', function () {
        var activeTab = qs('.tab-content.active');
        var input = activeTab && qs('input[type="text"]', activeTab);
        var value = input && (input.value || '').trim();
        var tabType = activeTab && activeTab.dataset.action;

        switch (tabType) {
          case 'VEÍCULO':
            buscarPorVeiculo(activeTab);
            break;
          case 'CÓDIGO DA PEÇA':
            buscarPorCodigoDaPeca(value);
            break;
          case 'BUSCA GERAL':
            buscarGeral(value);
            break;
          default:
            buscarPorVeiculo(activeTab);
        }
      });

    // Botão Limpar
    limparBtn &&
      limparBtn.addEventListener('click', function () {
        // limpa inputs (inclui #search-vehicles e os inputs de outras abas)
        qsa('.tab-content input').forEach(function (i) {
          i.value = '';
          i.disabled = false;
        });

        // limpa selects e fake-selects
        qsa('.tab-content select').forEach(function (s) {
          s.value = '';
          s.disabled = false;
          s.classList.remove('loading');
          updateFakeSelect(s, false);

          var wrapper = s.closest('.select-wrapper');
          if (wrapper) {
            wrapper.classList.remove('fake-select-disabled');

            var fakeInput = wrapper.querySelector('.fake-select-input');
            var fakeListWrap = wrapper.querySelector('.fake-select-list-wrap');

            if (fakeInput) {
              fakeInput.value = '';
              fakeInput.disabled = false;
            }
            if (fakeListWrap) {
              fakeListWrap.style.display = 'none';
              fakeListWrap.classList.remove('fake-select-disabled');
            }
          }
        });

        // re-sincroniza dependências da cadeia de veículo
        var selectMarca = qs('#select-marca');
        var selectModelo = qs('#select-modelo');
        var selectDescricao = qs('#select-descricao');
        syncFakeSelectDisabledByDependency(selectMarca);
        syncFakeSelectDisabledByDependency(selectModelo);
        syncFakeSelectDisabledByDependency(selectDescricao);

        var resultContainer = qs('#search-results');
        if (resultContainer) resultContainer.innerHTML = '';

        localStorage.removeItem('dadosVeiculoPorPlaca');
        var infoPlaca = qs('#placa-info');
        if (infoPlaca) infoPlaca.innerHTML = '';
      });

    // Selects da aba veículo
    configurarInteracoesDeVeiculo();
  }

  function limparResultadosRenderizados() {
    var container = qs('#search-results');
    if (container) container.innerHTML = '';
  }
})();
